export default __webpack_public_path__ + "static/media/Artist7.1a276491.svg";